import { DistributorModel, DiamondSupportListClient, DsListEntryModel } from "@/diamond-support-api"

export interface AssociateData {
    myInfo: TableItem[] | null;
    sponsorInfo: TableItem[] | null;
    status: TableItem[] | null;
}

export interface TableItem {
    text: string | null | undefined;
    name: string | null | undefined;
    value: string | null | undefined;
}

export interface DiamondData {
    id: string | undefined;
    distributorId: string  | undefined;
    businessName: string  | undefined;
    fullName: string  | undefined;
    mobilePhone: string  | undefined;
    secondPhone: string  | undefined;
    email: string  | undefined;
    country: string  | undefined;
    lastPaidRank: string  | undefined;
    lifetimeRank: string  | undefined;
    enrollmentDate: string  | undefined;
    renewalDate: string  | undefined;
    updatedUtc: Date  | undefined;
    isSpaData: boolean;

}

export class AssociateDataHelper {

    associateDetail = {
        myInfo: [
            { text: "Full Name", name: "fullName", value: "" },
            { text: "CO-APP FULL NAME", name: "coApplicantFullName", value: "" },
            { text: "BUSINESS NAME", name: "businessName", value: "" },
            { text: "ASSOCIATE ID", name: "distributorId", value: "" },
            { text: "ADDRESS", name: "fullAddress", value: "" },
            { text: "MOBILE PHONE", name: "mobilePhone", value: "" },
            { text: "2ND PHONE", name: "secondPhone", value: "" },
            { text: "EMAIL", name: "email", value: "" },
        ],
        sponsorInfo: [
            { text: "Full Name", name: "sponsorFullName", value: "" },
            { text: "Sponsor Id", name: "sponsorDistributorId", value: "" },
            { text: "Sponsor Email", name: "sponsorEmail", value: "" },
            { text: "Sponsor phone", name: "sponsorPhone", value: "" },
        ],
        status: [
            { text: "Associate Status", name: "associateStatus", value: "" },
            { text: "Last Paid Rank", name: "lastPaidRank", value: "" },
            { text: "Life Time Rank", name: "lifetimeRank", value: "" },
            { text: "Renewal Date", name: "renewalDate", value: "" },
            { text: "Date Achived", name: "enrollmentDate", value: "" },
        ],
    };
    getAssociateDetail(DistributorData: DistributorModel) {

        for (let [key, value] of Object.entries(DistributorData)) {
            for (let [k, v] of Object.entries(this.associateDetail)) {
                for (let [k1, v1] of Object.entries(v)) {
                    if (v1.name == key) {
                        v[parseInt(k1)].value = value;
                    }
                }
            }
        }
        return this.associateDetail;
    }
}

export class DiamondDataHelper {
    DistributorData: DistributorModel | any;
    diamondApi = new DiamondSupportListClient();
    DiamondList: DiamondData = {
        id: undefined,
        distributorId: undefined,
        fullName: undefined,
        businessName: undefined,
        mobilePhone: undefined,
        secondPhone: undefined,
        email: undefined,
        country: undefined,
        lastPaidRank: undefined,
        lifetimeRank: undefined,
        enrollmentDate: undefined,
        renewalDate: undefined,
        updatedUtc: undefined,
        isSpaData: false,
    }
    getDiamondList(DistributorData: DistributorModel) {
        var data = DistributorData
        if (DistributorData && DistributorData.distributorId) {
            this.DiamondList.distributorId = data.distributorId;
            this.DiamondList.fullName = data.fullName;
            this.DiamondList.businessName = data.businessName;
            this.DiamondList.mobilePhone = data.mobilePhone;
            this.DiamondList.secondPhone = data.mobilePhone;
            this.DiamondList.email = data.email;
            this.DiamondList.country = data.fullAddress?.split(" ")
                .pop();
            this.DiamondList.lastPaidRank = data.lastPaidRank;
            this.DiamondList.lifetimeRank = data.lifetimeRank;
            this.DiamondList.enrollmentDate = data.enrollmentDate;
            this.DiamondList.renewalDate = data.renewalDate;
            this.DiamondList.updatedUtc = new Date();
            this.DiamondList.isSpaData = true;
        }
        return this.DiamondList;

    }

}